import { apiService } from '../api/ApiService';

const API_BASE = '/api/public/currencies';

export type Currency = {
    id: string;
    currencyCode: string;
    symbol: string;
};

type PublicCurrenciesResponse = {
    currencies: Currency[];
};

class CurrencyService {
    public async getAllCurrencies(): Promise<Currency[]> {
        const payload = await apiService.request<PublicCurrenciesResponse>(API_BASE);

        if (!payload || !Array.isArray(payload.currencies)) {
            throw new Error('Invalid public currencies API shape');
        }

        return payload.currencies;
    }
}

export const currencyService = new CurrencyService();
